import { classNameMerger } from '@breetometer/utils';
import { FiatIcon } from 'BreetAssets';
import { CURRENCYCONFIG, getSafeObjectField } from 'BreetHelpers';

import type { IModernCurrencyDropdownItemOptions } from '../../Dropdown.helpers';

const ModernCurrencyItemOptions = ({
	items,
	selectedItem,
	handleItemSelection,
	CustomItemOption,
}: IModernCurrencyDropdownItemOptions) => (
	<>
		{items.map((item) => {
			const isSelected = !!selectedItem && selectedItem.currency === item.currency;

			return (
				<button
					type='button'
					key={item.currency}
					onClick={handleItemSelection(item)}
					className={classNameMerger('modern-dropdown_option', isSelected && 'selected')}
					data-testid={`modern-option-${item.currency}`}
					aria-current={isSelected ? 'true' : undefined}
					title={item.currency}
					name={item.currency}
				>
					{!CustomItemOption ? (
						<>
							<span className='dropdown_content_item_options_item_name color-primary-50'>
								{getSafeObjectField(CURRENCYCONFIG, item.currency)?.symbol}&nbsp;
								{item.walletBalance}
							</span>

							<span className='dropdown_content_item_options_item_flag'>
								<FiatIcon
									currencyCode={item.currency}
									variant='round'
								/>
							</span>
						</>
					) : (
						<CustomItemOption item={item} />
					)}
				</button>
			);
		})}
	</>
);

export default ModernCurrencyItemOptions;
